(function () {
    'use strict';

    angular
        .module('app')
        .factory('columnSetService', columnSetService);

    columnSetService.$inject = ['$http', '$q', '$filter'];

    function columnSetService($http, $q, $filter) {
        var service = {
            getColumnSets: getColumnSets,
            getColumnSetColumns: getColumnSetColumns,
            getColumnSetColumnsForPreview: getColumnSetColumnsForPreview,
            saveColumnSet: saveColumnSet,
            resizeColumns: resizeColumns,
            currentColumnSet: "",
            columnSetColumns: [],
            columnSets: [],
            fieldDefinitions: [],
            previewColumns: [],
            close: close
        };

        return service;

        //column set changed callbacks
        var changedCallbacks = [];

        // 2016-10-04
        function close() {
            service.currentColumnSet = "";
            service.columnSetColumns = [];
            service.columnSets = [];
            service.fieldDefinitions = [];
            service.previewColumns = [];
        }

        function getColumnSets() {
            var deferred = $q.defer();
            if (service.columnSets.length > 0) {
                deferred.resolve({ data: service.columnSets });
            }
            else {
                var promise = $http.get('../Synergis.WebApi/api/columnset').then(function (response) {
                    service.columnSets = response.data;
                    var searchResultsCS = $filter('filter')(service.columnSets, { name: "SearchResultColumns" });
                    if (searchResultsCS.length > 0) {
                        service.currentColumnSet = searchResultsCS[0].id;
                    }
                    deferred.resolve(response);
                });
            }

            return deferred.promise;
        }

        function getColumnSetColumns(columnSetId, getCached) {
            var deferred = $q.defer();

            var promise = $http.get('../Synergis.WebApi/api/column/'.concat(columnSetId)).then(function (response) {
                service.columnSetColumns = response.data;
                deferred.resolve(response);
            });

            return deferred.promise;;
        }

        function getColumnSetColumnsForPreview(columnSetId) {
            var deferred = $q.defer();
            var promise = $http.get('../Synergis.WebApi/api/column/'.concat(columnSetId)).then(function (response) {
                service.previewColumns = response.data;
                deferred.resolve(response);
            });
            return deferred.promise;;
        }


        function saveColumnSet(columnSet) {
            var columnSetId = columnSet.id;
            var columns = [];

            //only add valid columns.
            angular.forEach(columnSet.columns, function (item) {
                if (service.fieldDefinitions[item.schemaId]) {
                    columns.push(item);
                }
            });

            service.columnSetColumns = columns;
            var request = $http({
                url: '../Synergis.WebApi/api/column/'.concat(columnSetId),
                method: 'PUT',
                data: JSON.stringify(columns),
                headers: {
                    "Content-Type": "application/json"
                }
            });

            return request;
        }

        function resizeColumns(columnSet) {
            console.log(service.fieldDefinitions);
            var deferred = $q.defer();
            var columnSetId = columnSet.id;
            var columns = [];

            //only add valid columns.
            angular.forEach(columnSet.columns, function (item) {
                if (service.fieldDefinitions[item.schemaId]) {
                    item.width = parseInt(item.width);
                    columns.push(item);
                }
            });

            var request = $http({
                url: '../Synergis.WebApi/api/column/resize/'.concat(columnSetId),
                method: 'PUT',
                data: JSON.stringify(columns),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                deferred.resolve(response);
                columnSetChanged();
            }, function (response) {
                deferred.reject(response);
            })

            return deferred.promise;

        }

        function columnSetChanged() {
            angular.forEach(changedCallbacks, function (item) {
                item();
            });
        }

        //registers a callback for changed columnset
        service.onColumnSetChanged = function (callBack) {
            var alreadyRegistered = false;
            //figure out if the callback has already been registered
            angular.forEach(changedCallbacks, function (item) {
                if (item === callBack) {
                    alreadyRegistered = true;
                }
            });
            //do not add the callback if it has already been registered
            if (!alreadyRegistered) {
                changedCallbacks.push(callBack);
            }
        }

    }
})();